import * as fromRedAguaActions from '../../../actions/AdmMapa/RedAgua/RedAgua.actions';


export interface RedAguaState {
    loaded: boolean;
    loading: boolean;
    visible: boolean;
    hidden: boolean;
    error: any;
};

const initialStateRedAgua: RedAguaState = {
    loaded: false,
    loading: false,
    visible: false,
    hidden: false,
    error: null
};

export function redAguaReducer(state = initialStateRedAgua, action: fromRedAguaActions.RedAguaActions): RedAguaState {
    switch (action.type) {
        case fromRedAguaActions.SET_RED_AGUA:
            return {
                ...state,
                loading: true,
                loaded: false,
            };

        case fromRedAguaActions.SET_RED_SUCCESS:
            return {
                ...state,
                loading: false,
                loaded: true,
            };

        case fromRedAguaActions.SET_RED_FAILURE:
            return {
                ...state,
                loaded: false,
                loading: false,
                error: {...action.error}
            };

        case fromRedAguaActions.VISIBLE_RED:
            return {
                ...state,
                visible: true,
                hidden: false
            };
        case fromRedAguaActions.HIDDEN_RED:
            return {
                ...state,
                visible: false,
                hidden: true
            };
      default: {
        return state;
      }
    }
}
